import { USER_ROLE_APARTMENT_LOCATOR } from 'common/userRoles';

import { SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE } from 'api/actionTypes';

export default async function getApartmentLocatorsList({ state, apiClient }) {
  if (state.get(['apartmentLocators'])) {
    return;
  }
  await apiClient.postWithState({
    action: SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE,
    payload: {
      userRole: USER_ROLE_APARTMENT_LOCATOR,
    },
    queryId: USER_ROLE_APARTMENT_LOCATOR,
    state: state,
    onSuccess(apartmentLocators) {
      state.set(['apartmentLocators'], apartmentLocators);
    },
  });
}
